(function () {
    'use strict';

    angular.module('swif.openbase')
    .config(route)
    .factory('swifOpenbasePartnerService', swifOpenbasePartnerService)
    .controller('PartnerAddressUserController', PartnerAddressUserController)
    .controller('PartnerTypesController', PartnerTypesController)
    .controller('PartnerTypeController', PartnerTypeController)
    .controller('PartnersController', PartnersController)
    .controller('PartnerController', PartnerController)
    .controller('PartnerAddressesController', PartnerAddressesController)
    .directive('listGroupItemPartner', listGroupItemPartner)
    .directive('listGroupItemPartnerAddress', listGroupItemPartnerAddress)
    .directive('panelPartner', panelPartner)
    .directive('panelPartnerAddress', panelPartnerAddress)
    .directive('panelCustomerPartnerAddress', panelCustomerPartnerAddress)
    .directive('thumbnailPartnerAddress', thumbnailPartnerAddress);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/partners/table_view', {
            templateUrl: 'partials/openbase/partners_table_view.html',
            controller: 'PartnersController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
        $routeProvider.when('/configuration/partner_addresses/table_view', {
            templateUrl: 'partials/openbase/partner_addresses_table_view.html',
            controller: 'PartnerAddressesController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
        $routeProvider.when('/configuration/partners/explorer_view', {
            templateUrl: 'partials/openbase/partners_explorer_view.html',
            controller: 'PartnersController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
        $routeProvider.when('/configuration/partner_types/table_view', {
            templateUrl: 'partials/openbase/partner_types_table_view.html',
            controller: 'PartnerTypesController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }


    /**
     * @ngdoc service
     * @name swif.openbase.swifOpenbasePartnerService
     * @description manage partner & partner_address
     **/
    function swifOpenbasePartnerService($location, swif) {
        'ngInject';
        var debug = $location.search().debug || false;
        var service = {
            getServiceSuppliersFilter: getServiceSuppliersFilter,
            getServiceSuppliers: getServiceSuppliers,
            createPartnerCollection: createPartnerCollection,
            createPartnerTypeCollection: createPartnerTypeCollection,
            createPartnerAddressCollection: createPartnerAddressCollection,
            getPartnerCollection: getPartnerCollection,
            getPartnerTypeCollection: getPartnerTypeCollection,
            getPartnerAddressCollection: getPartnerAddressCollection,
            preModalPartner: preModalPartner,
            preValidatePartner: preValidatePartner,
            preModalPartnerType: preModalPartnerType,
            preValidatePartnerType: preValidatePartnerType,
            preValidatePartnerAddress: preValidatePartnerAddress,
            callbackPartner: callbackPartner,
            callbackPartnerType: callbackPartnerType,
            callbackPartnerAddress: callbackPartnerAddress
        };
        return service;

        function getServiceSuppliersFilter(filter, extra) {
            var partnerFilter = filter || {};
            if (!extra) {
                swif.data.addFilter(
                    partnerFilter,
                    'type_id.service_supplier', '=', true
                );
            } else {
                swif.data.addExtraFilter(
                    partnerFilter, extra,
                    'type_id.service_supplier', '=', true
                );
            }
            return partnerFilter;
        }
        function getServiceSuppliers(filter) {
            var partnerFilter = service.getServiceSuppliersFilter(filter);
            return swif.data.get('partner', undefined, partnerFilter);
        }
        function createPartnerCollection() {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            //if debug I want to list all partners
            if (!debug) {
                swif.data.addExtraFilter(filter, 'external', 'is_department', '=', false);
            }
            return swif.collections.createOrUpdate('partners', 'partner', filter, {location: true});
        }
        function createPartnerTypeCollection () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate('partner-types', 'partner_type', filter);
        }


        function createPartnerAddressCollection(item) {
            var filter = {};
            if (swif.module.hasModule('opengst_hospital_connector')) {
                filter.fields = [
                    ...swif.data.getFields('partner_address'),
                    'is_hospital_patient', 'customer_number', 'stay_number', 'civility',
                    'entry_date', 'planned_release_date', 'room_number', 'accommodation_unit'
                ];
            }
            swif.data.sortOn(filter, 'name', 'ASC');
            swif.data.addExtraFilter(filter, 'inCurrentPartner', 'id', 'in', item.address);
            return swif.collections.createOrUpdate(
                'partners-addresses',
                'partner_address',
                filter
            );
        }
        function getPartnerCollection() {
            return swif.collections.getCollection('partners');
        }
        function getPartnerTypeCollection() {
            return swif.collections.getCollection('partner-types');
        }

        function getPartnerAddressCollection() {
            return swif.collections.getCollection('partners-addresses');
        }
        function preModalPartner(data) {
            return service.getPartnerCollection().preModal(data);
        }
        function preValidatePartner(data) {
            return service.getPartnerCollection().preValidate(data);
        }
        function preModalPartnerType(data) {
            return service.getPartnerTypeCollection().preModal(data);
        }
        function preValidatePartnerType(data) {
            return service.getPartnerTypeCollection().preValidate(data);
        }

        function preValidatePartnerAddress(data) {
            var partner = service.getPartnerCollection();
            var res;
            if (partner) {
                res = partner.preValidate(data);
            } else {
                res = true;
            }
            if (data.action.id === 'add') {
                if (partner) {
                    if (partner.currentItem) {
                        data.model.partner_id = [partner.currentItem.id, partner.currentItem.name];
                    }
                }
            } else if (data.action.id === 'createuser') {
                var defer;
                var model = {
                    login: data.model.login,
                    password: data.model.password
                };
                defer = swif.data.callKw(
                    'partner_address',
                    'create_account',
                    [data.model.id, model]
                );
                defer.then(function () {
                    service.callbackPartnerAddress(undefined, data);
                }, function (err) {
                    service.callbackPartnerAddress(err);
                });
            }
            return res && true;
        }
        function callbackPartner(error, data) {
            var collection = service.getPartnerCollection();
            if (collection) {
                collection.defaultActionCallback(error, data);
            }
        }
        function callbackPartnerType(error, data) {
            var collection = service.getPartnerTypeCollection();
            if (collection) {
                collection.defaultActionCallback(error, data);
            }
        }
        function callbackPartnerAddress(error, data) {
            var collection = service.getPartnerAddressCollection();
            if (collection) {
                collection.defaultActionCallback(error, data);
            }
            if (!error) {
                if (data.action.id === 'createuser') {
                    swif.message.addInfo('User created successfully');
                    collection.updateItem(data.model);
                }
            }
        }
    }


    function PartnerAddressUserController($scope, swifOpenbaseUserService) {
        'ngInject';
        $scope.dot = {};
        $scope.loading = {users: {}};
        //$scope.model is a partner_address
        if ($scope.model.user_id) {
            $scope.already_exist = true;
        }
        function searchForUSers(login) {
            swifOpenbaseUserService.searchForUSers(login)
            .then(function (users) {
                $scope.users = users;
            });
        }
        function alreadyExist(login) {
            $scope.already_exist = true;
            swifOpenbaseUserService.getUserWithLogin(login)
            .then(function (user) {
                if (user) {
                    $scope.already_exist = true;
                    $scope.user = user;
                    $scope.model.user_id = [user.id, user.name];
                } else {
                    $scope.already_exist = false;
                    delete $scope.model.user_id;
                    delete $scope.user;
                }
            });
        }
        $scope.$watch('model.login', function (newV) {
            if (newV) {
                searchForUSers(newV);
                alreadyExist(newV);
            }
        });
    }


    function PartnerTypesController($scope, swifOpenbasePartnerService) {
        'ngInject';
        swifOpenbasePartnerService.createPartnerTypeCollection()
        .then(function (collection) {
            $scope.partnerTypes = collection;
        });
        $scope.preValidate = swifOpenbasePartnerService.preValidatePartnerType;
        $scope.callback = swifOpenbasePartnerService.callbackPartnerType;
    }


    function PartnerTypeController($scope) {
        'ngInject';
        $scope.$watch('model.supplier', function (newV) {
            if (!newV) {
                $scope.model.product_supplier = false;
                $scope.model.service_supplier = false;
            }
        });
    }


    function PartnersController($scope, $location, swif, swifOpenbasePartnerService, swifOpenbaseCompanyService, goNetEndpointApi) {
        'ngInject';
        console.log('Init PartnersController')

        swifOpenbaseCompanyService.getGlobalSettings().then( company => {
            $scope.is_canadian = company.is_canadian;
            swif.data.is_canadian = $scope.is_canadian
            if ($scope.is_canadian) {
                goNetEndpointApi.getGoNetToken()
            }
        })
        $scope.debug = $location.search().debug ? true : false;
        $scope.modules = swif.module.modules;
        $scope.hasModuleHospital = swif.module.hasModule('opengst_hospital_connector');
        $scope.loading = {partner_address: {}};
        swifOpenbasePartnerService.createPartnerCollection().then(function (collection) {
            $scope.partners = collection;
        });
        $scope.preModalPartner = swifOpenbasePartnerService.preModalPartner;
        $scope.preModalPartnerAddress = swifOpenbasePartnerService.preModalPartnerAddress;
        $scope.preValidatePartner = swifOpenbasePartnerService.preValidatePartner;
        $scope.preValidatePartnerAddress = swifOpenbasePartnerService.preValidatePartnerAddress;
        $scope.callbackPartner = swifOpenbasePartnerService.callbackPartner;
        $scope.callbackPartnerAddress = swifOpenbasePartnerService.callbackPartnerAddress;
        $scope.$watch('partners.currentItem', function (newV) {
            if (!newV) {
                return;
            }
            var addresses = swif.collections.getCollection('partners-addresses');
            if (addresses) {
                //empty the collection;
                addresses.items = [];
            }
            //dataService.addFilter(filter, 'partner_id.id', 'in', [partner.id]);
            swif.message.loading($scope.loading.partner_address);
            swifOpenbasePartnerService.createPartnerAddressCollection(newV)
            .then(function (addresses) {
                swif.message.loading($scope.loading.partner_address, 'ok');
                $scope.partnerAddresses = addresses;
            }, function () {
                swif.message.loading($scope.loading.partner_address, 'ko');
            });
        });
    }

    function PartnerController($scope, $window, swif, goNetEndpointApi, swifOpenbasePartnerService) {
      'ngInject';
      console.log('Init PartnerController')



      if ($scope.model.is_canadian === undefined) {
        // checking when modal open if user's company is canadian
        $scope.model.is_canadian = swif.data.is_canadian
        $scope.model.showSearchGoNet = (swif.$location.$$path === '/configuration/partners/table_view' && $scope.model.is_canadian)
      }

      if($scope.model.is_canadian){
        $scope.$watch("model.name",function(value) {
            if (value && value.length >= 3) {
                let filters = {};
                swif.data.addFilter(filters, 'name', 'ilike', value);
                swif.data.searchRead('partner', filters).then(function (partner) {
                    if (partner.ids.length > 0) {
                        $scope.model.partnerAlreadyExists = true;
                        $scope.model.matchedPartner = partner.ids[0];
                    } else {
                        delete $scope.model.matchedPartner;
                        $scope.model.partnerAlreadyExists = false;
                    }
                    $scope.form['model.name'].$setValidity(
                        "default",
                        partner.ids.length === 0
                    );
                })
            }
        })

        let partner_data = swifOpenbasePartnerService.getPartnerCollection();
        // conditions necessary for using this code in other part of code, exemple in request when we create a partner
        if ($scope.model.partner_id === undefined && partner_data !== undefined){
            let partner = partner_data.currentItem;
            if (partner !== undefined){
                $scope.model.partner_id = [partner.id, partner.name];
            }
        }

        //only important if the company is canadian
        $scope.onChangeName = function (value) {
            if(value && value.length >= 3){
                let filters = {};
                swif.data.addFilter(filters, 'name', 'ilike', value);
                swif.data.addFilter(filters, 'partner_id', '=', $scope.model.partner_id[0]);
                swif.data.searchRead('partner_address', filters).then(function(partner_address){
                    if(partner_address.ids.length > 0){
                        $scope.partnerAlreadyExist = true;
                        $scope.matchedPartnerAddress = partner_address.ids[0];
                    } else {
                        delete $scope.matchedPartnerAddress;
                        $scope.partnerAlreadyExist = false;
                    }
                    $scope.form['model.name'].$setValidity(
                        "default",
                        partner_address.ids.length === 0
                    );
                })
            }
        }
      }


      $scope.modules = swif.module.modules;
      $scope.hasModuleHospital = swif.module.hasModule('opengst_hospital_connector');
      $scope.filters = {
          partner_type: {"fields": ["name", "service_supplier"]},
          department: {},
          departments: {},
          site: {},
          sites: {},
          canadian_muni: {fields: ['name', 'address', 'codemuni', 'layer_id']}
      };

      $scope.isBookableVisibility = false;

      // if we have already a type_id, we get the service_supplier value to check if we have to show the bookable checkbox
      if ($scope.model.type_id) {
          swif.data.get('partner_type', $scope.model.type_id[0], {fields: ['service_supplier']}).then(response => {
              $scope.isBookableVisibility = response.service_supplier;

              // Include assignable_to_task if current user are part of a service organization
              if (response.service_supplier) {
                  swif.data.addFilter($scope.filters.departments, '|');
                  swif.data.addFilter($scope.filters.departments, 'is_assignable_to_task', '=', true);
              }
              swif.data.addFilter($scope.filters.departments, 'is_assignable_to_ask', '=', true);
          });
      }

      var getDepartmentsFilter = function () {
          var ret = {};
          if ($scope.isBookableVisibility) {
              // If service supplier, we allow them to pick assignable to task service
              swif.data.addFilter(ret, '|');
              swif.data.addFilter(ret, 'is_assignable_to_task', '=', true);
          }
          swif.data.addFilter(ret, 'is_assignable_to_ask', '=', true);
          if (!_.isEmpty($scope.model.technical_service_ids)) {
              swif.data.addFilter(ret, 'id', 'in', $scope.model.technical_service_ids);
          }
          return ret;
      };
      var getSitesFilter = function () {
          var ret = {};
          if (!_.isEmpty($scope.model.technical_site_ids)) {
              swif.data.addFilter(ret, 'id', 'child_of', $scope.model.technical_site_ids);
          }
          return ret;
      };
      $scope.updateIsBookableVisibility = function(partner_type) {
          $scope.isBookableVisibility = partner_type.service_supplier;
          if (!$scope.isBookableVisibility) {
              $scope.model.is_bookable = false;
          }
      }
      $scope.$watchGroup(
          ['model.technical_service_ids', 'model.technical_site_ids'],
          function (newV, oldV) {
              if (!angular.equals(newV, oldV)) {
                  $scope.filters.department = getDepartmentsFilter();
                  $scope.filters.site = getSitesFilter();
              }
          }
      );
  }

    function PartnerAddressesController($scope, $location, $routeParams, dataService, collections, swifOpenbasePartnerService) {
        'ngInject';
        $scope.currentFilter = {};
        $scope.preModal = swifOpenbasePartnerService.preModalPartnerAddress;
        $scope.preValidate = swifOpenbasePartnerService.preValidatePartnerAddress;
        $scope.callback = swifOpenbasePartnerService.callbackPartnerAddress;
        collections.createOrUpdate(
            'partners-addresses',
            'partner_address',
            {}
        ).then(function (collection) {
            $scope.partnerAddresses = collection;
        });
        $scope.setCurrentItem = function (item) {
            $location.search('partnerAddressId', item.id);
            dataService.get('partner_address', item.id)
            .then(function (address) {
                if (address.partner_id) {
                    dataService.get('partner', address.partner_id[0])
                    .then(function (partner) {
                        $scope.$parent.setCurrentItem(partner)
                        .then(function () {
                            $scope.$parent.currentAddress = address;
                            $scope.currentItem = address;
                        });
                    });
                } else {
                    $scope.currentItem = address;
                    $scope.$parent.currentAddress = address;
                }
            });
        };
        if ($location.search().partnerAddressId !== undefined) {
            dataService.get('partner', $location.search().partnerAddressId)
            .then(function (partner) {
                $scope.setCurrentItem(partner);
            });
        }
    }


    function listGroupItemPartner() {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                listGroupItemPartner: '='
            },
            templateUrl: 'partials/openbase/list-group-item-partner.html'
        };
    }


    function listGroupItemPartnerAddress() {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                listGroupItemPartnerAddress: '='
            },
            templateUrl: 'partials/openbase/list-group-item-partner-address.html'
        };
    }


    function panelPartner(swifPanelService) {
        'ngInject';
        var directive = swifPanelService.create_directive('partner');
        directive.templateUrl = 'partials/openbase/panel-partner.html';
        return directive;
    }


    function panelPartnerAddress(swifPanelService) {
        'ngInject';
        var directive = swifPanelService.create_directive('partner_address');
        directive.templateUrl = 'partials/openbase/panel-partner-address.html';
        return directive;
    }


    function panelCustomerPartnerAddress(swif, swifPanelService) {
        'ngInject';
        var filter = {};
        filter.fields = [
            ...swif.data.getFields('partner_address'),
            'is_hospital_patient', 'customer_number', 'stay_number', 'civility',
            'entry_date', 'planned_release_date', 'room_number', 'accommodation_unit'
        ];
        var directive = swifPanelService.create_directive('partner_address', filter);
        directive.templateUrl = 'partials/openbase/panel-customer-partner-address.html';
        return directive;
    }


    function thumbnailPartnerAddress(swif) {
        'ngInject';
        var filter = {fields: ['name', 'function', 'partner_id', 'has_image']};
        var ret = swif.panel.create_directive('partner_address', filter);
        ret.scope.light = '=?';
        ret.templateUrl = 'partials/openbase/thumbnail-partner-address.html';
        return ret;
    }


})();
